import { Button } from "@/components/ui/button"
import { XIcon } from "lucide-react"
import { useTranslation } from "react-i18next"

interface PreviewProps {
  photoPreview: string
  onRemove: () => void
}

export function Preview({ photoPreview, onRemove }: PreviewProps) {
  const { t } = useTranslation()

  return (
    <div className="relative">
      <img 
        src={photoPreview} 
        alt={t('common.photo')} 
        className="w-full h-48 object-contain rounded-md border"
      />
      <Button
        type="button"
        variant="destructive"
        size="icon"
        className="absolute top-2 right-2"
        onClick={onRemove}
      >
        <XIcon className="h-4 w-4" />
      </Button>
    </div>
  )
} 